import { Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import Layout from './components/Layout'
import Login from './components/Login'
import GoogleCallback from './components/GoogleCallback'
import Dashboard from './components/Dashboard'
import Projects from './components/Projects'
import Contracts from './components/Contracts'
import Hosting from './components/Hosting'
import Profile from './components/Profile'
import Support from './components/Support'
import Homepage from './components/Homepage'
import AboutUs from './components/AboutUs'
import Contact from './components/Contact'
import Register from './components/Register'
import Terms from './components/Terms'
import Privacy from './components/Privacy'
import ProtectedRoute from './components/ProtectedRoute'
import TrackTicket from './components/TrackTicket'
import WalletTransaction from './components/WalletTransaction'
import CustomerProfile from './components/CustomerProfile'
import LandingPages from './components/LandingPages'

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Homepage />} />
        <Route path="/home" element={<Homepage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/register" element={<Register />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/login" element={<Login />} />
        <Route path="/auth/google/callback" element={<GoogleCallback />} />
        <Route path="/track" element={<TrackTicket />} />
        
        {/* Protected Routes - Customer Portal */}
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <Layout>
              <Dashboard />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/projects" element={
          <ProtectedRoute>
            <Layout>
              <Projects />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/contracts" element={
          <ProtectedRoute>
            <Layout>
              <Contracts />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/hosting" element={
          <ProtectedRoute>
            <Layout>
              <Hosting />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/profile" element={
          <ProtectedRoute>
            <Layout>
              <Profile />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/support" element={
          <ProtectedRoute>
            <Layout>
              <Support />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/wallet" element={
          <ProtectedRoute>
            <Layout>
              <WalletTransaction />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/customer-profile" element={
          <ProtectedRoute>
            <Layout>
              <CustomerProfile />
            </Layout>
          </ProtectedRoute>
        } />
        <Route path="/landing-pages" element={
          <ProtectedRoute>
            <Layout>
              <LandingPages />
            </Layout>
          </ProtectedRoute>
        } />
       
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
    </AuthProvider>
  )
}

export default App
